<template>
  <div class="d-flex align-items-center">
    <div class="mr-1">
      <span>{{ params.displayName }}</span>
      <i
        v-if="params.showThStar"
        class="fas fa-asterisk text-danger icon-sm"
        title="Zum Zeitpunkt der Buchung"
        v-b-tooltip.hover
        style="align-self: start; position: absolute"
      ></i>
    </div>
    <b-button
      class="btn-xs btn p-2 mr-1 justify-content-center align-item-center d-flex"
      v-b-tooltip.hover
      :title="hoverText"
    >
      <i class="fas fa-info m-0 p-0 fa-xs"></i>
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'CustomInfoIconHeader',
  data() {
    return {
      params: null,
    };
  },
  computed: {
    // Muss per headerComponentParams gesetzt werden
    hoverText() {
      return this.params?.hoverText || '';
    },
  },
  beforeMount() {
    this.params = this.params || {};
  },
};
</script>
